import script from "./SponsorView.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorView.vue?vue&type=script&setup=true&lang=js"

import "./SponsorView.vue?vue&type=style&index=0&id=44131402&lang=css"

const __exports__ = script;

export default __exports__